module.exports = __webpack_public_path__ + "static/media/motic outcome1.4c724659.png";